<template>
  <div>
    <el-dialog :title="titleName" @close="closeDialog" :visible.sync="dialogVisable" :modal-append-to-body="false" width="850px" height="504px"
      style="margin-top:4vh;" class="add-label-dialog" :close-on-click-modal="false">
      <div class="btn-wrap" v-if="KHSOPcd || myType==3">
        <div>
          <el-select v-if="myType==3" v-model="selectMark" placeholder="是否完成" size="mini" @change="selectType" style="width: 140px; margin-right: 10px;">
            <el-option
              v-for="(item,index) in typeOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        
        <el-button
          v-if="KHSOPcd"
          type="primary"
          size="mini"
          @click="handleExport()"
          >导出</el-button
        >
      </div>
      
      <tableWrap>
        <template #table>
          <el-table 
            size="medium" 
            :header-cell-style="{background:'#eef1f6',color:'#606266'}" 
            ref="returnVisitSOPTable"
            height="400px"
            :highlight-current-row="true" 
            v-loading="isLoading"
            :data="tableData" 
            style="width: 100%;font-size: 13px">
            <el-table-column v-for="(item,index) in tableHeader" :key="item.id" :label="item.label" :prop="item.id" :min-width="item.minWidth"  :align="item.align" >
            </el-table-column>
          </el-table>
        </template>
        <template #pagination>
          <Pagination v-bind:childMsg="pageparm" :pageSizes="pageSizes" @callBack="callBack"></Pagination>
        </template>
      </tableWrap>
    </el-dialog>
  </div>
</template>
<script>
import tableWrap from "@/components/tabelWrap.vue"
export default {
  name: "DataDialog",
  components: {
    tableWrap
  },
  props: {
    KHSOPcd: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    titleName: {
      type: String,
      default: '新增好友SOP'
    },
    tableHeader: {
      type: Array,
      default: ()=>([])
    },
    tableData: {
      type: Array,
      default: ()=>([])
    },
    myVisiable: {
      type: Boolean,
      default: false
    },
    myType: {
      type: Number,
      default: 1
    },
    pageparm: {
      type: Object,
      default: ()=>( {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      })
    },
  },
  data() {
    return {
      dialogVisable: false,
      pageSizes: [10, 50, 100, 200,500], //分页条数
      typeOptions: [
        {
          label: '全部',
          value: -1
        },
        {
          label: '已完成',
          value: 1
        },
        {
          label: '未完成',
          value: 0
        },
      ],
      selectMark: -1
    };
  },
  created() {
  },
  watch: {
    myVisiable(val) {
      this.dialogVisable = val
      if(this.myType == 3) {
        this.selectMark = -1
      }
    }
  },
  computed: {
   
  },
  methods: {
    selectType() {
      this.$emit('reGet',0,this.selectMark)
    },
    // 导出
    handleExport() {
      this.$emit('handleExport')
    },
    closeDialog() {
      this.$emit("closeDialog", false);
    },
    callBack(parm) {
      this.$emit('reGet',parm)
    }
  },
  
  
};
</script>
<style lang="scss" scoped>
 .btn-wrap {
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
}
</style>